import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import styled from 'styled-components';


const StyledHeroSection = styled.section`
  min-height: 50vh;
  padding: 24px 0 150px 0;
  text-align: center;
  padding-top:110px;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

	h1{
	 font-family: var(--title-font);
    width: 84.666667%;
    margin: 0 auto;
    font-size: 36px;;
    line-height: 1.4;
    font-weight: 600;
    
    @media (min-width: 480px) {
       font-size: 40px;
    }
    @media (min-width: 1024px) {
      font-size: 50px;
    }
}

`;

const Hero = () => {
   const data = useStaticQuery(graphql`
    query IntroQuery {
      site {
        siteMetadata{
          intro
        }
      }
    }
  `)

  return (
    <StyledHeroSection>
    	<h1 className="big-heading">{data.site.siteMetadata.intro}</h1>
    </StyledHeroSection>
  );
};

export default Hero;
